import React from "react";
import styles from "./StartVerification.module.css";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import verifiedImage from "../../../assets/images/Wide.png";
import { useProfile } from "../../../contexts/ProfileContext";

function StartVerification() {
    const navigate = useNavigate();
    const { profileData } = useProfile();
    let verification_status = profileData?.verification_status;
    const handleStartVerification = () => {
        navigate("/verify/step-1");
    };

    return (
        <div className="tw-h-screen tw-flex tw-flex-col tw-justify-between tw-bg-white tw-overflow-y-auto">
            <Header title="Identity Verification" />
            <div className="tw-flex tw-flex-col tw-justify-between tw-h-full tw-max-w-[1180px] tw-mx-auto tw-mt-20 max-sm:tw-mt-10 tw-px-4">
                <div className={`tw-flex tw-flex-col tw-items-center tw-w-full`}>
                    <div className="tw-px-[50px] max-sm:tw-px-4 tw-py-[25px] max-sm:tw-py-4 tw-w-full tw-bg-white tw-rounded-lg">
                        <div className={styles.textContent}>
                            <div className={styles.headlineWrapper}>
                                <img
                                    loading="lazy"
                                    // src="https://cdn.builder.io/api/v1/image/assets/TEMP/4e7e849b4bd4b8e7be0e2d544f95f413c0ed634e57af00cbcea4fbf0021e8758?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                                    src={verifiedImage}
                                    className={styles.logo}
                                    alt="Home Insurance Logo"
                                />
                                <h1 className={`${styles.headline} tw-text-[30px] max-sm:tw-text-[24px] tw-mt-5 max-sm:tw-mt-3`}>
                                    Verify Your Identity or Company in 3 Minutes
                                </h1>
                                <p className="tw-text-[20px] max-sm:tw-text-[16px] tw-font-[500] tw-text-black tw-mt-10 max-sm:tw-mt-6">
                                    Secure your account and unlock full access to property transactions.
                                </p>
                                <div className="tw-flex tw-justify-center">
                                    <div className="tw-flex tw-flex-col md:tw-flex-row tw-mt-5 max-sm:tw-mt-3 tw-w-full tw-justify-center tw-gap-10 max-sm:tw-gap-6 2xl:tw-w-[70%]">
                                        <div className="tw-w-full">
                                            <div className="tw-bg-[#f1fbf9] tw-border tw-border-border_color tw-p-6 max-sm:tw-p-4 tw-rounded-md tw-flex tw-flex-col tw-items-center tw-gap-5 max-sm:tw-gap-3">
                                                <p className="tw-font-bold tw-text-black">Personal Identity</p>
                                                <p className="tw-text-black tw-text-[14px] max-sm:tw-text-[13px] tw-text-center">
                                                    {verification_status === "approved" ? (
                                                        <span className="tw-font-bold">
                                                            Your account is fully verified and no additional verification steps are required at this
                                                            time.{" "}
                                                        </span>
                                                    ) : (
                                                        "Verify yourself using a government-issued ID to build trust and unlock full platform access."
                                                    )}
                                                </p>
                                                <button
                                                    disabled={verification_status === "approved"}
                                                    style={verification_status === "approved" ? { pointerEvents: "none", opacity: 0.5 } : {}}
                                                    className={`tw-px-5 max-sm:tw-px-4 tw-rounded-md tw-bg-primary hover:tw-bg-primary_hover tw-py-2 max-sm:tw-py-3 tw-w-full max-sm:tw-text-sm`}
                                                    onClick={handleStartVerification}
                                                >
                                                    <span
                                                        className={
                                                            "tw-text-center tw-font-thin tw-text-white tw-text-[13px] max-sm:tw-text-[14px] 3xl:tw-text-[16px]"
                                                        }
                                                    >
                                                        Start verification
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="tw-hidden md:tw-flex tw-flex-col tw-items-start tw-mt-5">
                                                <p className="tw-text-gray-700 tw-font-medium tw-mb-2">For Personal Verification:</p>
                                                <ul className="tw-text-gray-600 tw-text-sm tw-space-y-2 tw-text-left">
                                                    <li>• A valid government-issued ID (driver's license or passport)</li>
                                                    <li>• Good lighting and a plain background</li>
                                                    <li>• Your device's camera</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="tw-w-full">
                                            <div className="tw-bg-[#f1fbf9] tw-border tw-border-border_color tw-p-6 max-sm:tw-p-4 tw-rounded-md tw-flex tw-flex-col tw-items-center tw-gap-5 max-sm:tw-gap-3">
                                                <p className="tw-font-bold tw-text-black">Company Verification</p>
                                                <p className="tw-text-black tw-text-[14px] max-sm:tw-text-[13px] tw-text-center">
                                                    Verify your business (LLC, Inc, or Corp) to operate professionally and display a verified company
                                                    badge.
                                                </p>
                                                <button
                                                    className={`tw-px-5 max-sm:tw-px-4 tw-rounded-md tw-bg-primary hover:tw-bg-primary_hover tw-py-2 max-sm:tw-py-3 tw-w-full max-sm:tw-text-sm`}
                                                    onClick={() => navigate("/company-verification/information")} // Add onClick handler
                                                >
                                                    <span
                                                        className={
                                                            "tw-text-center tw-text-[13px] max-sm:tw-text-[14px] 3xl:tw-text-[16px] tw-font-thin tw-text-white"
                                                        }
                                                    >
                                                        Start verification
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="tw-hidden md:tw-flex tw-flex-col tw-items-start tw-mt-5">
                                                <p className="tw-text-gray-700 tw-font-medium tw-mb-2">What You'll Need:</p>
                                                <ul className="tw-text-gray-600 tw-text-sm tw-space-y-2 tw-text-left">
                                                    <li>• Your registered business name</li>
                                                    <li>• Corporate formation documents (PDF, JPG, or PNG)</li>
                                                    <li>• Owner’s ID and a selfie photo</li>
                                                    <li>• State/Country of incorporation</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Information Section */}
                        <div className="tw-text-left tw-mb-8 tw-mt-5">
                            {/* <p className="tw-text-gray-700 tw-font-medium tw-mb-2">What You'll Need:</p> */}

                            <div className="md:tw-hidden tw-flex tw-flex-col tw-w-full tw-justify-center">
                                <div>
                                    <p className="tw-text-gray-700 tw-font-medium tw-mb-2">For Personal Verification:</p>
                                    <ul className="tw-text-gray-600 tw-text-sm tw-space-y-2">
                                        <li>• A valid government-issued ID (driver's license or passport)</li>
                                        <li>• Good lighting and a plain background</li>
                                        <li>• Your device's camera</li>
                                    </ul>
                                </div>
                                <div>
                                    <p className="tw-text-gray-700 tw-font-medium tw-mb-2">What You'll Need:</p>
                                    <ul className="tw-text-gray-600 tw-text-sm tw-space-y-2">
                                        <li>• Your registered business name</li>
                                        <li>• Corporate formation documents (PDF, JPG, or PNG)</li>
                                        <li>• Owner’s ID and a selfie photo</li>
                                        <li>• State/Country of incorporation</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className={` tw-w-full tw-text-center tw-mb-10`}>
                            <p className={` tw-text-center`}>
                                Your security is our priority. All data is encrypted and securely stored in compliance with data protection
                                regulations.
                            </p>
                            <a onClick={() => navigate("/privacy-policy")} className={`${styles.footerLink} tw-text-center`}>
                                Learn more about our privacy policy
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StartVerification;
